import { Box, Typography } from '@mui/material';
import { useLocation } from "react-router-dom";

// MOBILE NAVIGATION MENU BUTTON
export default function MobileNavigationMenuButton({ name }: MobileNavigationMenuButtonProps) {
    const location = useLocation();

    // RETURN ELEMENT
    return (
        <Box sx={{ px: 3, py: 1.55 }}>
            <Typography
                component="a"
                href={`/${(name.toLowerCase()).replace(/\s/g, '')}`}
                variant="h5"
                aria-label={name}
                sx={{
                    '&:hover': {
                        color: 'var(--teal_brighter)'
                    },
                    fontFamily: 'Public Sans',
                    fontStyle: 'italic',
                    color: (location.pathname === '/' ? '/home' : location.pathname) === `/${name.toLowerCase().replace(/\s/g, '')}` ? 'var(--teal_brighter)' : 'white',
                    cursor: 'pointer',
                    transition: '.23s',
                    textDecoration: 'none'
                }}
            >
                {name}
            </Typography>
        </Box>
    )
}
